import React, {useLayoutEffect, useState} from 'react';
import styles from './styles';
import {Button, ClickOverlay} from '@xpertdox_js/xdcomponents';
import SubPanel from './SubMenu';
import {ScrollContext} from '../Utils/ScrollContext';
import {DataTableContext} from '../Utils/DataTableContext';
import handleDownload from '../Utils/download';
import { trackActivity } from '../../../utils/activityTracker';
import { UserContext } from '../../../Context/UserContext'
import { InstanceContext } from '../../../InstanceContext'


const Sidebar = props => {

  const {headers, scrollEffect} = React.useContext(ScrollContext);
  const {controller} = React.useContext(DataTableContext);
  useLayoutEffect(() => scrollEffect());

  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }


  // deafault items state
  let initialMenuState = {dt_headers: false, dt_default_download: false};

  // default menus
  let menuItemSettings = [
    {
      title: 'Headers',
      id: 'dt_headers',
      type: 'default',
      setter: 'defaultActions',
      setterParam: 'headers',
      options: props.headers.map(headerObj => {
        return({
          text: headerObj.title,
          id: headerObj.id,
          setterParam: headerObj.id,
          setter: props.toggleHeader,
          condition: props.currentHeaders.includes(headerObj.id),
          type: 'toggle'
        });
      })
    },
    {
      title: 'Download',
      id: 'dt_default_download',
      // type: 'default',
      options: [
        {
          text: 'CSV File',
          id: 'dt_download_csv',
          setterParam: 'csv',
          setter: type => {
            console.log(type)
            handleDownload((props.options.downloadFilename || 'downloaded_data.csv'), type, controller)
            activateItem('dt_download_csv')
          },
        },
        {
          text: 'Excel(XLSX) File',
          id: 'dt_download_excel',
          setterParam: 'xlsx',
          setter: type => {
            console.log(type)
            handleDownload((props.options.downloadFilename || 'downloaded_data.xlsx'), type, controller)
            activateItem('dt_download_excel')
          },
        },
      ]
    }
  ];


  // merge dev settings into default
  if (props.settings) {
    // settings merge
    const defaultIDs = menuItemSettings.map(obj => obj.id);
    menuItemSettings = [...menuItemSettings, ...props.settings.menuItems];
    // active state merge
    menuItemSettings.forEach(menuObj => {
      if (!defaultIDs.includes(menuObj.id)) {
        initialMenuState[menuObj.id] = false;
      }
    })
  }

  // menu item panel display state
  const [menuItems, setMenuItems] = useState(initialMenuState);


  const activateItem = (id) => {
    const update = {...menuItems};
    Object.keys(menuItems).forEach(key => {
      update[key] = key === id && !update[key];
    })
    setMenuItems(update);
    handleActivityLogUpdate(`Sidebar.activateItem`)

  }



  // --- end initialize

  // check if any menu is active & get settings
  let activeMenuIndex = null;
  const aMenuIsActive = Object.values(menuItems).filter((val, i) => {
    if (val) activeMenuIndex = i;
    return val;
  }).length > 0;
  if (!aMenuIsActive) activeMenuIndex = null;

  const activeMenuItem = aMenuIsActive
  ? Object.keys(menuItems).filter(key => menuItems[key])[0]
  : null;

  const activeMenuSettings = menuItemSettings
  .filter(item => item.id === activeMenuItem)[0];

  // clsoe menu items
  const closeMenus = () => {
    let stateUpdate = {...menuItems};
    Object.keys(stateUpdate).forEach(key => stateUpdate[key] = false);
    setMenuItems(stateUpdate)
  }

  const subMenuRightValue = props.tableElement.current && headers
  ? (document.body.clientWidth - props.tableElement.current.getBoundingClientRect().left - props.tableElement.current.offsetWidth)
  + 27 + 'px'
  : '30px';

  return(
    <React.Fragment>
      {/* sidebar nav */}
      <nav style={styles.container}>
          <div style={{
            position: headers ? 'fixed' : 'relative',
            top: headers ? (props.customTopOffset || 0) : 0,
            width: '30px',
            transition: '.2s ease-out'
          }}>
            {menuItemSettings.map((miObject, i) => {
              const menuItemStyles = i !== activeMenuIndex
                ? styles.menuItem : styles.menuItemActivated;
              const dynamicStyles = {
                transform: `translateY(${100 * i}%) rotate(90deg)`,
                marginTop: `${35 + (2 * (i ? i + 1.5 : i))}px`,
              }
              return(
                <Button
                  key={miObject.id}
                  styles={{
                    ...menuItemStyles,
                    ...dynamicStyles
                  }}
                  hoverStyles={i === activeMenuIndex
                    ? {...styles.menuItemHov, ...styles.menuItemActivated, ...dynamicStyles}
                    : styles.menuItemHov
                  }
                  activeStyles={styles.menuItemAct}
                  focusStyles={styles.focusStyles}
                  onClick={activateItem}
                  clickParam={miObject.id}
                >
                  {miObject.title}
                </Button>

              );
            })
          }
        </div>
      </nav>

      {/* Headers Menu */}
      {aMenuIsActive &&
        <React.Fragment>
          <SubPanel
            data={props.data}
            settings={activeMenuSettings}
            actions={props.settings ? props.settings.actions : null}
            top={activeMenuIndex * 100
            + (headers && props.customTopOffset ? parseInt(props.customTopOffset) : 0) + 'px'}
            fixed={headers}
            right={subMenuRightValue}
          />
        <ClickOverlay event={closeMenus} zIndex={4} />
        </React.Fragment>
      }

    </React.Fragment>
  );
}

export default Sidebar;
